import { useMutation, useQuery } from "@apollo/client";
import { useCallback } from "react";
import { getFragmentData, graphql } from "../gql";
import { OnboardingLiveCreationIntentFragment } from "./OnboardingLiveFragments.ts";

export const GetOnboardingLiveCreationIntentsQuery = graphql(`
  query getOnboardingLiveCreationIntents {
    getOnboardingLiveCreationIntents {
      ...OnboardingLiveCreationIntentItem
    }
  }
`);

const CreateIntentMutation = graphql(`
  mutation createOnboardingLiveCreationIntent($userGroupId: String!) {
    createOnboardingLiveCreationIntent(userGroupId: $userGroupId) {
      id
    }
  }
`);

export function useOnboardingLiveCreationIntents() {
  const { data, loading } = useQuery(GetOnboardingLiveCreationIntentsQuery, {
    fetchPolicy: "cache-and-network",
  });
  const [createMutation, { loading: creating }] = useMutation(
    CreateIntentMutation,
    { refetchQueries: [GetOnboardingLiveCreationIntentsQuery] },
  );
  const createIntent = useCallback(
    async (userGroupId: string) => {
      const { data } = await createMutation({ variables: { userGroupId } });
      const intentId = data?.createOnboardingLiveCreationIntent.id;
      if (!intentId) throw new Error("Plan not created");
      return intentId;
    },
    [createMutation],
  );
  return {
    intents:
      getFragmentData(
        OnboardingLiveCreationIntentFragment,
        data?.getOnboardingLiveCreationIntents,
      ) ?? [],
    loading,
    createIntent,
    creating,
  };
}
